import { PropsWithChildren, useEffect } from 'react';
import { RootState, useAppDispatch } from './store';
import { useSelector } from 'react-redux';
import { EActionState } from './models';
import { actionCreator } from './store/application';
import { SplashScreen } from './components/splashscreen';

export const InitProvider = (props: PropsWithChildren) => {
	const dispatch = useAppDispatch();
	const initAction = useSelector(
		(state: RootState) => state.application.init
	);

	useEffect(() => {
		if (initAction === EActionState.PENDING) {
			dispatch(actionCreator.INIT_START());
		}
	});

	if (initAction === EActionState.COMPLETED) {
		return props.children;
	}

	return <SplashScreen />;
};
